<template>
  <validation-provider
    :name="name"
    :rules="validate"
    v-slot="{ errors, invalid, validated }"
    :mode="validateMode"
    slim
  >
    <vvs-control-wrapper
      :label="label"
      :description="description"
      :is-required="isRequired"
      :error="errors[0]"
      :loading="loading"
      :normal-label="normalLabel"
    >
      <input
        v-if="mask"
        :type="type"
        v-model="proxy"
        v-mask="mask"
        @input="onInput($event)"
        class="form_input"
        :class="{ error: validated && invalid }"
        v-bind="formControlOptions"
      />
      <input
        v-else
        :type="type"
        v-model="proxy"
        @input="onInput($event)"
        class="form_input"
        :class="{ error: validated && invalid }"
        v-bind="formControlOptions"
      />
    </vvs-control-wrapper>
  </validation-provider>
</template>

<script>
import formControlMixin from '@/mixins/form.control.mixin';
export default {
  name: 'VvsInput',
  mixins: [formControlMixin],
  props: {
    type: {
      type: String,
      default: 'text',
    },
  },
};
</script>
